export const SET_DETAIL_TABLE = 'boilderplate/PreviewAndSubmit/SET_DETAIL_TABLE';

export const LOADER_STATUS = 'boilderplate/PreviewAndSubmit/LOADER_STATUS';

export const SET_FILE_DATA = 'boilderplate/PreviewAndSubmit/SET_FILE_DATA';

export const SET_OTP_BOX = 'boilderplate/PreviewAndSubmit/SET_OTP_BOX';

export const OTP_INVALID = 'boilderplate/UploadedData/OTP_INVALID';

export const SET_FILE_ERROR = 'boilderplate/UploadedData/SET_FILE_ERROR'